import React from 'react';
import { useSelector } from 'react-redux';

import { selectDarkMode } from '../../userBrowserSettings/store/browserSettings.selectors';
import { colorPalette } from '../styles/colorPalette';

const CloseIcon = ({ color = '', size = '20' }) => {
    const darkMode = useSelector(selectDarkMode);

    let iconColor = color;

    if (!color?.length) {
        iconColor = darkMode ? colorPalette.textColor.dark : colorPalette.textColor.light;
    }

    return (
        <svg
            width={size}
            height={size}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='stroke-icon'
        >
            <path
                d='M15 5L5 15'
                stroke={iconColor}
                strokeWidth='1.2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5 5L15 15'
                stroke={iconColor}
                strokeWidth='1.2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default CloseIcon;
